(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pro-apply"] && !Shopify.designMode) return;
  try {
    
/* Demande pro — le panier doit partir avec le formulaire.

   Le champ est déjà rempli par Liquid au chargement : sans JavaScript, la
   demande part quand même avec le panier tel qu'il était à l'ouverture.
   Ce script ne fait que deux choses de plus :
     · rafraîchir le contenu au moment de l'envoi, si le panier a bougé ;
     · bloquer une demande dont le panier est vide, plutôt que d'envoyer
       une demande creuse que le commercial devra faire compléter.

   Aucun tarif professionnel n'est calculé ici. Les prix sont ceux du
   panier réel ; la grille HT n'est pas confirmée. */
(function () {
  'use strict';

  var form = document.getElementById('OtmProApply');
  if (!form) return;

  var field = form.querySelector('[data-pro-cart]');
  var hint = form.querySelector('[data-pro-cart-hint]');
  var tierField = form.querySelector('[data-pro-tier]');
  if (!field) return;

  /* money() n'est plus appelée depuis la décision client du 05/09/2026 :
     le brief envoyé au commercial ne porte plus de montant. Elle est
     conservée, pas supprimée — rallumer les prix ne demandera qu'un
     rappel ici. */
  function money(cents) {
    if (window.otmCart && window.otmCart.money) return window.otmCart.money(cents);
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
  }

  var VIDE = 'Aucune selection : le prospect a envoye sa demande sans composer de panier.';

  function serialise(cart) {
    if (!cart || !cart.item_count) return VIDE;
    var lignes = cart.items.map(function (i) {
      var titre = i.product_title;
      if (i.variant_title && i.variant_title.indexOf('Default') === -1) titre += ' (' + i.variant_title + ')';
      var l = i.quantity + ' x ' + titre;
      if (i.sku) l += ' \u2014 ref ' + i.sku;
      return l;
    });
    lignes.push('TOTAL : ' + cart.item_count + ' unite' + (cart.item_count > 1 ? 's' : ''));
    return lignes.join('\n');
  }

  /* Le palier, recalcule sur le panier relu a l'envoi. Les seuils viennent
     du metaobjet tarif_pro : ce sont des entiers, plus le premier mot d'une
     tranche affichee. Aucun prix ne circule ici — la page est publique. */
  function borne(t) {
    return t.max > 0 ? (t.min + ' a ' + t.max) : (t.min + ' et plus');
  }

  function serialisePalier(cart) {
    if (!tierField) return null;
    var tiers;
    try { tiers = JSON.parse(tierField.dataset.proTiers || '[]'); }
    catch (e) { return null; }

    var total = (cart && cart.item_count) || 0;
    var pluriel = total > 1 ? 's' : '';

    if (!tiers.length) {
      return 'Aucun bareme publie : palier non determinable. '
           + 'Quantite totale du panier : ' + total + ' unite' + pluriel + '.';
    }
    if (total === 0) return 'Panier vide : aucun palier atteint.';

    var atteint = null;
    tiers.forEach(function (t) { if (total >= t.min) atteint = t; });

    var entete = 'Quantite totale du panier : ' + total + ' unite' + pluriel + '.';
    if (!atteint) {
      return entete + '\nAucun palier atteint : le premier commence a '
           + tiers[0].min + ' unites (' + borne(tiers[0]) + ').';
    }
    return entete + '\nPalier atteint : ' + borne(atteint)
         + (atteint.devis ? ' — sur devis.' : '');
  }

  function setHint(txt, vide) {
    if (!hint) return;
    hint.textContent = txt;
    hint.classList.toggle('is-error', !!vide);
  }

  /* On n'utilise pas un drapeau persistant : une fois levé, il court-circuiterait
     la garde panier-vide à toute soumission suivante. On retire l'ecouteur juste
     avant de soumettre, et on le repose si la navigation n'a pas lieu. */
  /* Un champ de livraison vide part quand meme : Shopify liste toutes les
     paires contact[...] dans le mail, et trois lignes vides font croire a
     une saisie oubliee. On les neutralise a l'envoi plutot que de les
     retirer du DOM — le revendeur peut rouvrir le bloc. */
  function neutraliserLivraison() {
    var champs = form.querySelectorAll('[data-livraison-field]');
    var rempli = false;
    Array.prototype.forEach.call(champs, function (c) {
      if (c.value.trim() !== '') rempli = true;
    });
    Array.prototype.forEach.call(champs, function (c) { c.disabled = !rempli; });
  }

  function envoyer() {
    neutraliserLivraison();
    form.removeEventListener('submit', onSubmit);
    form.submit();
    setTimeout(function () { form.addEventListener('submit', onSubmit); }, 2000);
  }

  function onSubmit(e) {
    e.preventDefault();

    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var txt = serialise(cart);
        field.value = txt;
        var palier = serialisePalier(cart);
        if (tierField && palier !== null) tierField.value = palier;
        if (!txt) {
          setHint(field.dataset.emptyMessage
            || "Ton panier est vide. Ajoute les references qui t'interessent avant d'envoyer la demande.", true);
          field.setAttribute('aria-invalid', 'true');
          field.focus();
          return;                  /* demande creuse bloquee */
        }
        field.removeAttribute('aria-invalid');
        envoyer();
      })
      .catch(function () {
        /* Le panier n'a pas pu etre relu : on laisse partir avec la valeur
           rendue par Liquid plutot que de bloquer une demande legitime. */
        envoyer();
      });
  }

  form.addEventListener('submit', onSubmit);
})();

  } catch(e) { console.error(e); }
})();
})();
